module.exports = __webpack_public_path__ + "img/button_More.c3fdf32b.svg";